module.exports = __webpack_public_path__ + "static/img/government.613a49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/government.png
// module id = 2w4h
// module chunks = 44